// import { app, scriptService } from "../../feathers";
import { actions } from "../../actionsProcessor";
// import { EventBus } from "../../eventBus";
// import router from "../../routes.js";
// import runHook from "Js/hookHandler";

// Diagnostic logging - set window._debugActions = true to enable
const debugLog = (category, data) => {
  if (typeof window !== 'undefined' && window._debugActions) {
    console.log(`[${category}]`, data);
  }
};

export default {
  state: {
    actions: [],
    threads: [],
    threadPromises: {}, // Map of idThread -> {resolve, reject} for Promise-based completion tracking
    isRunning: false, // Never set, kept for backward compatibility
    isPaused: false
  },

  actions: {
    ACTIONS_QUEUE: ({ commit, state, dispatch, rootState }, actionsArrOrObj ) => {
      // var actionsArrOrObjCopy = actionsArrOrObj ? _.cloneDeep(actionsArrOrObj) : actionsArrOrObj;
      
      // Create a Promise that will resolve when this thread completes
      const promise = new Promise((resolve, reject) => {
        
        if ( _.isEmpty(actionsArrOrObj) || ( actionsArrOrObj.actions  && _.isEmpty(actionsArrOrObj.actions)) )  {
          //Neded to continue thread in case of empty named actions
          actionsArrOrObj && actionsArrOrObj.actions  && _.isEmpty(actionsArrOrObj.actions) ? dispatch("ACTIONS_DO", {idThread: actionsArrOrObj.idThread}) : null
          resolve(); // Resolve immediately if empty
          return;
        }
        var actionsArray = [];
        var idThread = (actionsArrOrObj && actionsArrOrObj.idThread) || Date.now();
        var isInsert = !! actionsArrOrObj && actionsArrOrObj.insert // if obj
        var idForm = (!Array.isArray(actionsArrOrObj) && actionsArrOrObj.idForm) ? actionsArrOrObj.idForm : '';
        if (!idForm) {
          idForm = _.get(rootState, 'wndw.queueTargetFormId') || '';
        }
        if (!idForm) {
          const activeWndId = rootState.wndw.idWndwActive;
          const activeWnd = rootState.wndw.windows && rootState.wndw.windows.find(w => w.id === activeWndId);
          idForm = _.get(activeWnd, 'formSchema.id') || _.get(rootState.wndw.windows, '[0].formSchema.id');
        }
        
        actionsArray = Array.isArray(actionsArrOrObj) ? actionsArrOrObj : actionsArrOrObj.actions

        if (!actionsArray || !actionsArray.length) {
          //Neded to continue thread in case of empty named actions
          dispatch("ACTIONS_DO", {idThread: (actionsArrOrObj && actionsArrOrObj.idThread) || null})
          resolve(); // Resolve immediately if no actions
          return;
        }
        
        actionsArray.forEach(action => {
          if (!action.idThread) action.idThread = idThread;
          if (!action.idForm) action.idForm = idForm;
          
          state.threads.indexOf(action.idThread) === -1 ? state.threads.push(action.idThread) : null
        })

        // Store resolve/reject for this thread. If another waiter already
        // registered the same idThread (e.g. Date.now() collision), chain so
        // POP_THREAD resolves every waiter — never orphan the earlier promise.
        if (state.threadPromises[idThread]) {
          const prev = state.threadPromises[idThread];
          state.threadPromises[idThread] = {
            resolve: () => { prev.resolve(); resolve(); },
            reject: (err) => { prev.reject(err); reject(err); }
          };
        } else {
          state.threadPromises[idThread] = { resolve, reject };
        }
        
        actionsArray[0].preventClone
          ? null
          : (actionsArray = _.cloneDeep(actionsArray));
        isInsert ? commit("QUEUE_ACTIONS_INSERT", actionsArray) : commit("QUEUE_ACTIONS", actionsArray);
        // state.isRunning ? null : actions.process();
        
        // Start processing - must be inside Promise to ensure proper sequencing
        dispatch("ACTIONS_DO", {idThread: actionsArray[0].idThread});
      });

      return promise;
    },

    ACTIONS_DO: async ({ commit, state, dispatch }, {idThread}) => {
      // runs the actioal actions but checks if they are running already etc
      
      if (window._debugActions) {
        const activeThreads = [...new Set(state.actions.map(a => a.idThread))];
        debugLog('ACTIONS_DO START', { 
          idThread, 
          queueLength: state.actions.length, 
          activeThreads,
          queueThreads: state.actions.map(a => a.idThread) 
        });
      }
      
      if(state.isPaused) {
        setTimeout( 
        function(){ 
          dispatch('ACTIONS_DO', {idThread}); //idThread
        }
        , 50)
        return
      }

      // isRunning check kept for backward compatibility but never actually set
      // Threads can execute concurrently - queue access is protected by atomic operations
      if(state.isRunning) return;
      
      const action = await dispatch("ACTIONS_GET", {idThread});
      
      // Log if thread gets wrong action (cross-thread interference)
      if (action && action.idThread !== idThread) {
        console.warn('🔴 RACE CONDITION: Thread got wrong action!', { 
          requestedThread: idThread, 
          gotThread: action.idThread,
          action: action.action,
          hint: 'Enable window._debugActions=true for detailed logs'
        });
      }
      
      if (window._debugActions) {
        debugLog('ACTIONS_DO Got action', { 
          idThread, 
          action: action ? action.action : null, 
          actionThread: action ? action.idThread : null 
        });
      }
      
      if (!action) {
        // No actions in the queue
        if (window._debugActions) {
          debugLog('ACTIONS_DO No action found', { idThread });
        }
        commit('POP_THREAD', idThread)
        return;
      }
      
      if (window._debugActions) {
        debugLog('ACTIONS_DO Dispatching', { idThread, action: action.action });
      }
      await actions.dispatchAction(action);
      
      if (window._debugActions) {
        debugLog('ACTIONS_DO Completed', { idThread, action: action.action });
      }
      
      if (action.nonBlocking) dispatch("ACTIONS_DO", {idThread})
      return;
    },

    ACTIONS_GET: ({ commit, state }, {idThread}) => {
      if (window._debugActions) {
        debugLog('ACTIONS_GET START', { 
          idThread, 
          queueLength: state.actions.length,
          queue: state.actions.map(a => ({ action: a.action, thread: a.idThread }))
        });
      }
      
      var action = null;
      if (state.actions.length) {
        if (!idThread) {
          action = state.actions[0];
          if (window._debugActions) {
            debugLog('ACTIONS_GET No thread specified', { action: action.action, thread: action.idThread });
          }
          commit("POP_ACTION");
          return action;
        }
        var index = state.actions.findIndex(e => e.idThread === idThread)
        
        if (window._debugActions) {
          debugLog('ACTIONS_GET Search result', { idThread, foundIndex: index, queueLength: state.actions.length });
        }
        
        // FIXED: Only call POP_ACTION when action is actually found
        if (index !== -1) {
          action = state.actions[index];
          if (window._debugActions) {
            debugLog('ACTIONS_GET Found action', { idThread, index, action: action.action });
          }
          commit("POP_ACTION", index);
        } else {
          if (window._debugActions) {
            debugLog('ACTIONS_GET No action found', { idThread });
          }
        }
      }
      else {
        if (window._debugActions) {
          debugLog('ACTIONS_GET Queue empty', {});
        }
        // Clear orphaned threads (those without active promises)
        // This prevents the race condition where active promises get auto-resolved
        state.threads.forEach(threadId => {
          if (!state.threadPromises[threadId]) {
            // Thread has no active promise - safe to clean up
            commit('POP_THREAD', threadId);
          }
        });
      }
      return action;
    },

    ACTIONS_CLEAR: ({ commit, state }, action) => {
      //If action is passed, it will clear only actions for the same thread as current action
      if (action && action.idThread) {
          let idThread = action.idThread
          let actionIndex = state.actions.findIndex(e => e.idThread === idThread);
          while (actionIndex !== -1) {
            commit("POP_ACTION", actionIndex);
            actionIndex = state.actions.findIndex(e => e.idThread === idThread);
          }
          commit('POP_THREAD', idThread) // This will resolve the promise
          return;
        }
      
      // Clear all actions and resolve all pending promises
      Object.keys(state.threadPromises).forEach(idThread => {
        if (state.threadPromises[idThread]) {
          state.threadPromises[idThread].resolve();
        }
      });
      state.threadPromises = {};
      state.actions = [];
      state.isRunning = false;
      return;
    },
    
    ACTIONS_PAUSE: ({ state }, isPaused) => {
      // commit('PAUSE_ACTIONS', isPaused)
      state.isPaused = isPaused // not seeming to update fast enough
      return;
    }
  },

  mutations: {
    QUEUE_ACTIONS: (state, actions) => {
      if (actions.length) {
        if (!state.actions) {
          state.actions = [];
        }
        actions.forEach(function(action) {
          state.actions.push(action);
        });
      }
    },
    
    QUEUE_ACTIONS_INSERT: (state, actions) => {
      if (actions.length) {
        if (!state.actions) {
          state.actions = [];
        }
        state.actions = actions.concat(state.actions);
      }
    },

    POP_ACTION: (state, index) => {
      if (window._debugActions) {
        debugLog('POP_ACTION START', { 
          index, 
          queueLength: state.actions.length,
          queueBefore: state.actions.map(a => ({ action: a.action, thread: a.idThread }))
        });
      }
      
      if (index === undefined || index === null) {
        const removed = state.actions.shift();
        if (window._debugActions) {
          debugLog('POP_ACTION Shifted', { removed: removed ? { action: removed.action, thread: removed.idThread } : null });
        }
        return;
      }
      
      if (index !== -1) {
        const removed = state.actions.splice(index, 1);
        if (window._debugActions) {
          debugLog('POP_ACTION Spliced', { 
            index, 
            removed: removed[0] ? { action: removed[0].action, thread: removed[0].idThread } : null,
            queueAfter: state.actions.map(a => ({ action: a.action, thread: a.idThread }))
          });
        }
      } else {
        // This is the bug condition - we're being asked to pop at index -1
        console.warn('🔴 BUG: POP_ACTION called with index -1 (no-op)', { 
          queueLength: state.actions.length,
          queue: state.actions.map(a => ({ action: a.action, thread: a.idThread }))
        });
      }
    },
    
    PAUSE_ACTIONS: (state, isPaused ) => {
      state.isPaused = isPaused
    },
    
    POP_THREAD: (state, idThread) => {
      let index = state.threads ? state.threads.findIndex(e => e === idThread) : -1;
      (state.threads.length && (index !== -1)) ? state.threads.splice(index, 1) : null;
      
      // Resolve the promise for this thread if it exists
      if (state.threadPromises[idThread]) {
        state.threadPromises[idThread].resolve();
        delete state.threadPromises[idThread];
      }
    },
    
    CLEAR_THREADS: (state) => {
      // Resolve any pending promises before clearing
      Object.keys(state.threadPromises).forEach(idThread => {
        if (state.threadPromises[idThread]) {
          state.threadPromises[idThread].resolve();
        }
      });
      state.threadPromises = {};
      state.threads = []
    }
  },

  getters: {
    getActionsQueue: state => {
      return state.actions;
    }}
};
